const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';

export default function Inspector({ attributes, setAttributes }) {
  return (
    <InspectorControls>
      <PanelBody title="Dados do Card (Mobile e Desktop)" initialOpen={true}>
        <ImageControl
          image="image_small"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <ImageControl
          image="image_large"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <TextControl
          label="Título do Card"
          value={attributes.title}
          onChange={(value) => setAttributes({ title: value })}
        />

        <TextControl
          label="Subtítulo do Card"
          value={attributes.subtitle}
          onChange={(value) => setAttributes({ subtitle: value })}
        />

        <TextControl
          label="Descrição do Card"
          value={attributes.title_bottom}
          onChange={(value) => setAttributes({ title_bottom: value })}
        />

        <TextControl
          label="Subdescrição do Card"
          value={attributes.subtitle_bottom}
          onChange={(value) => setAttributes({ subtitle_bottom: value })}
        />

        <TextControl
          label="Texto Botão"
          value={attributes.button}
          onChange={(value) => setAttributes({ button: value })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
}
